import { useEffect, useState } from 'react';
import styled from 'styled-components';

export const StyledLatLng = styled.div`
  position: absolute;
  left: auto;
  bottom: 20px;
  right: 0px;
  /* Account for different Mapbox attribution styles */
  @media (max-width: 1152px) {
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    right: auto;
  }
  background-color: hsla(0, 0%, 100%, 0.8);
  padding: 2px 5px;
  font-size: 12px;
`;

// This is the precision of the LngLat values from Mapbox. It's used to
// avoid jitter by always displaying the same number of digits, including
// trailing zeros.
const DIGITS = 14;

const CursorLatLng = ({ className, mapRef, mapLoaded }) => {
  const [latLng, setLatLng] = useState();

  useEffect(() => {
    if (!mapLoaded) return null;
    const map = mapRef.current;
    const onMouseMove = (e) => {
      setLatLng(e.lngLat);
    };
    map.on('mousemove', onMouseMove);
    return () => map.off('mousemove', onMouseMove);
  }, [mapLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!latLng) return null;
  return (
    <StyledLatLng className={className}>
      {latLng.lat.toFixed(DIGITS)},{latLng.lng.toFixed(DIGITS)}
    </StyledLatLng>
  );
};

export default CursorLatLng;
